import { render, staticRenderFns } from "./PageManageBrand.vue?vue&type=template&id=2aad2e59&"
import script from "./PageManageBrand.vue?vue&type=script&lang=js&"
export * from "./PageManageBrand.vue?vue&type=script&lang=js&"
import style0 from "./PageManageBrand.vue?vue&type=style&index=0&id=2aad2e59&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports